<script>
var user;
//const pre = "/api";
//测试的外注appID
const appId = "ww7ed042c3f5fb6cb0";
//现场的外注appId
// const appId = "ww831300ebd28a585b";
// const domain = "localhost:8007";
// 现场的外注domain
// const domain = "app.toray.cn:1009";
//const domain = "192.168.10.83:8007";
//const domain = "cjqty.nyy.com.cn";
//测试的外注domain
const domain = "qy.nyy.com.cn";
//const domain = "terpqty.nyy.com.cn";
const pre = "";
//const mui = require("../assets/js/mui.js");

const protocol = document.location.protocol;
const wsProtocol = (protocol === "https:" ? "wss://" : "ws://");

let  jsSHA = require("jssha");


const u = navigator.userAgent;
window.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
window.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端


const createNonceStr = function () {
  return Math.random().toString(36).substr(2, 15);
};

const createTimestamp = function () {
  return parseInt(new Date().getTime() / 1000) + '';
};

const raw = function (args) {
  let keys = Object.keys(args);
  keys = keys.sort()
  let newArgs = {};
  keys.forEach(function (key) {
    newArgs[key.toLowerCase()] = args[key];
  });

  let string = '';
  for (const k in newArgs) {
    string += '&' + k + '=' + newArgs[k];
  }
  string = string.substr(1);
  return string;
};


const sign = function (jsapi_ticket,nonceStr,timestamp, url) {
  let ret = {
    jsapi_ticket: jsapi_ticket,
    nonceStr: nonceStr,
    timestamp: timestamp,
    url: url
  };
  const string = raw(ret);
  const shaObj = new jsSHA(string, 'TEXT');
  ret.signature = shaObj.getHash('SHA-1', 'HEX');

  return ret;
};


const doPost =function(url, paras, callback, onFailure){
	if(!url){
		console.log("http://"+domain+url);
	}
	$.ajax({
		type: "POST",
		url:pre+url,
    //url: url,
		timeout : 30000, //超时时间设置，单位毫秒
		//contentType:"application/json;charset=utf-8",  //发送信息至服务器时内容编码类型。
		dataType:"json",  // 预期服务器返回的数据类型。如果不指定，jQuery 将自动根据 HTTP 包 MIME 信息来智能判断，比如XML MIME类型就被识别为XML。
		data:{"postData":JSON.stringify(paras)},
		// beforeSend:function(xhr){
		// 	if(user)xhr.setRequestHeader(appkey, appsecretHead+user.token);
		// 	//xhr.setRequestHeader(appkey, appsecretHead+"eyJhbGciOiJIUzI1NiIsImlhdCI6MTUyNDE0MjY1OSwiZXhwIjoxNTI1OTQyNjU5fQ.MQ.TsDE0S6BhZH502xrF7KDEvzx9azlxDaYlmepHvCh2ks");
		// 	//xhr.setRequestHeader(appkey, appsecretHead+"eyJhbGciOiJIUzI1NiIsImlhdCI6MTUyNjAwMjcwNSwiZXhwIjoxNTMzNzc4NzA1fQ.NQ.umVKgutp-jMHRF7sBZ98jLDvlycxFRFHB7l7mFCAsE8");
		// },
		success: function(rtn){
			if(rtn){
			  if(rtn.status == true){
          try{
            callback(rtn);
          }catch(e){
            alert(e.message);
          }
        }
			  else{
			    if(rtn.code =="4000"){
            mui.alert('请退出重新进入应用', rtn.message,function(){
               wx.closeWindow();
            });
			    }
			    else if(rtn.code =="1001"){
            // checkLogin("请重新输入密码",rtn.message);
            mui.alert(rtn.message, '消息提示',function(){
               wx.closeWindow();
            });
          }
			    else{
            try{
              //mui.toast(rtn.message)
              callback(rtn);
            }catch(e){
              alert(e.message);
            }
          }
        }

			}
		},
		error: function(XMLHttpRequest, textStatus, errorThrown) {
			if(onFailure){
				onFailure(XMLHttpRequest, textStatus, errorThrown);
			}else{
				mui.toast('啊，网络似乎开小差了。。。',{ duration:'long'});
			}

		}
	});
};


const doGet =function(url, callback, onFailure){
    $.ajax({
        type: "GET",
        url:"http://"+domain+url,
        data:"",
        beforeSend:function(xhr){
            //xhr.setRequestHeader(appkey, appsecretHead+"eyJhbGciOiJIUzI1NiIsImlhdCI6MTUyNTY4MjI3NiwiZXhwIjoxNTI3NDgyMjc2fQ.NQ.pItfcCPrJyKoF_fKeLzkA9Ao7eb9L1lhNDBq-MKupT0");
        },
        success: function(rtn){
            if(rtn){
                try{
                    callback(rtn);
                }catch(e){
                    alert(e.message);
                }
            }
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
            mui.toast('啊，网络似乎开小差了。。。');
        }
    });
};

//文件上传
const upload = function(url, para, form, callback){

  form.attr('target', '_self');
  form.attr('method', 'post');
  form.attr('enctype', 'multipart/form-data');
  form.attr('action', pre+url);

  let input1 = $('<input>');
  input1.attr('type', 'hidden');
  input1.attr('name', 'postData');
  input1.attr('value', JSON.stringify(para));

  form.append(input1);
  form.ajaxSubmit({
    async:false,
    dataType: 'json',
    success: function(rtn){
      if(rtn){
        if(rtn.status == true){
          try{
            callback(rtn);
          }catch(e){
            alert(e.message);
          }
        }
        else{
          if(rtn.code =="4000"){
            mui.alert('请退出重新进入应用', rtn.message,function(){
              wx.closeWindow();
            });
          }
          else if(rtn.code =="1001"){
            checkLogin("请重新输入密码",rtn.message);
          }
          else{
            try{
              mui.toast(rtn.message)
              callback(rtn);
            }catch(e){
              alert(e.message);
            }
          }
        }

      }
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      if(onFailure){
        onFailure(XMLHttpRequest, textStatus, errorThrown);
      }else{
        mui.toast('啊，网络似乎开小差了。。。',{ duration:'long'});
      }

    }
  });
  input1.remove();

}

//文件下载
const download= function(url, para){

  let form = $("<form>");
  form.attr('style', 'display:none');
  form.attr('target', '_blank');
  form.attr('method', 'post');
  form.attr('action', pre+url);

  let input1 = $('<input>');
  input1.attr('type', 'hidden');
  input1.attr('name', 'postData');
  input1.attr('value', JSON.stringify(para));

  $('body').append(form);
  form.append(input1);

  form.submit();

  form.remove();

}
// 下载更新
const doUpd=function(url){
	cordova.exec(
		function(result) {
			try {
	    		result =eval("("+result+")");
	            callback(result);
			} catch(e) {
				// statements
				console.log(e);
			}

	    },
	    function(result) {
	    	if(result == "PERMISSION_DENIED"){
	    		mui.alert("当前应用缺少必要权限，暂时无法使用。如若需要，请前往设置中心进行权限授权。");
	    		return;
	    	}
	        alert("failed>>" + result.message);
	    },
	    "Update",
	    "run",
	    [{url:url}]
	);
};

// 登录校验
const checkuser=function(v,callback){
	if(user){
		if(callback) callback();
	}else{
		v.$router.push("login");
	}
}

const checkLogin = function(title, message,callfunc){
  mui.prompt(message,'',title,new Array('确定'),function(e){
    var password = "";
    if(e.index == 0){
      password = document.querySelector('.mui-popup-input input').value.trim();
    }
    doPost("/Main/CheckLogin", {"password":password},
      function(result) {
        if (result.status) {
          if(password=="111111"){
            firstLogin("您使用的是原始密码","请输入新密码",callfunc);
          }else{
            callfunc();
          }
        }
        else {
          checkLogin("登录提示", result.message +'请重新输入密码！',callfunc);
        }
      });
  },'div');

  var tt = document.querySelector('.mui-popup-input');
  tt.innerHTML = "<input type='password' placeholder='请重新输入您的密码' maxlength= '10' />"
}

const firstLogin = function(title, message,callfunc){
  mui.prompt(message,'',title,new Array('确定'),function(e){
    var password = "";
    if(e.index == 0){
      password = document.querySelector('.mui-popup-input input').value.trim();
    }
    doPost("/Main/ChangePassword", {"opassword":"111111","password":password},
      function(result) {
        if (result.status) {
          //alert(result.data.userid)
          callfunc();
        }
        else {
          // firstLogin(result.message, '请重新输入密码！')
          mui.toast(result.message)
        }
      });

  },'div');

  var tt = document.querySelector('.mui-popup-input');
  tt.innerHTML = "<input type='password' placeholder='请重新输入您的密码' maxlength= '10' />"
}

// 微信初始化
const wxInit = function(readyfunc){
    var url = window.location.href.indexOf("#") >= 0 ? window.location.href.substring(0, window.location.href.IndexOf("#")) : window.location.href;
    doPost("/Main/GetTicket", {},function(result){
          if (result.status) {
            const ticket = result.data
            const timestamp = createTimestamp();
            const nonceStr = createNonceStr();
            const signature = sign(ticket,nonceStr,timestamp, url).signature;
            wx.config({
              beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
              //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: appId, // 必填，企业微信的corpID
              timestamp: timestamp, // 必填，生成签名的时间戳
              nonceStr: nonceStr, // 必填，生成签名的随机串
              signature: signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
              jsApiList: ['getLocation','chooseImage','uploadImage','scanQRCode','previewImage'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            })
            wx.error(function(res){
              //mui.toast(JSON.stringify(res));
              if(res.errCode != 0){
                //mui.toast("微信初始化配置异常，请稍候再试。");
              }
            })
            wx.ready(function(){
                if(readyfunc){
                  readyfunc();
                }
            });
        }else {
            mui.alert(result.message,"错误提示",function(){
              wx.closeWindow();
            });
        }
   });
}

const nextFocus = function(event){
    var currentname = $(event.target)[0].name;
    $('.nextfocus').each(function(index){
      var t = $(this);
      if(t != $(event.target) && t[0].disabled == false){
          if(parseInt(t[0].name)  > parseInt(currentname)){
            t.focus();
            return false;
          }
      }
    });
}

/**
 * 判断空值
 */
const isEmpty = (val) => {
	if (typeof val === 'string') {
		val = val.replace(/\"|&nbsp;|\\/g, '').replace(/(^\s*)|(\s*$)/g, '');
		if (val == '' || val == null || val == 'null' || val === 'undefined') {
			return true;
		} else {
			return false;
		}
	} else if (typeof val === 'undefined') {  // 未定义
		return true;
	} else if (typeof val === 'number') {
		return false;
	} else if (typeof val === 'boolean') {
		return false;
	} else if (typeof val == 'object') {
		if (JSON.stringify(val) == '{}') {
			return true;
		} else if (val == null) { // null
			return true;
		} else {
			return false;
		}
	}

	if (val instanceof Array && val.length == 0) {// 数组
		return true;
	}

}

const scanQRCode = function(type, options, v) {
  if (type == 0) {
    // 使用微信接口进行扫码
    wx.scanQRCode(options);
  } else {
    // 使用插件进行扫码(跳到指定页面)
    if (v && options) {
      options.id = createNonceStr();
      if (v.$router.currentRoute.name == 'scan') {
        v.$router.replace({
          name: 'scan',
          params: options
        });
      } else {
        v.$router.push({
          name: 'scan',
          params: options
        });
      }
    }
  }
}
////////////////////////////////////////

 export default
 {
    get userInfo(){
        return user;
    },
    set userInfo(val) {
        user = val;
    },
    appId,
    domain,
	  doPost,
    doGet,
    doUpd,
    checkuser,
    checkLogin,
    firstLogin,
    createNonceStr,
    createTimestamp,
    sign,
    upload,
    download,
    wxInit,
    nextFocus,
    wsProtocol,
    isEmpty,
    protocol,
    scanQRCode
 }




</script>



// WEBPACK FOOTER //
// src/components/Global.vue